import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context/src/app-context';
import { promptToast } from '../../../components/toast-container/actions';

import { Errors } from '../types';

export function useReviewErrorToast() {
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  function dispatchReviewErrorToast(errorCode: Errors | null) {
    if (!errorCode) return;

    switch (errorCode) {
      case Errors.USER_ALREADY_HAS_REVIEW:
        dispatch(
          promptToast('error', t('reviews', 'error.user-already-has-review'))
        );
        break;

      case Errors.USER_CONNECTED_TO_STORE:
        dispatch(
          promptToast('error', t('reviews', 'error.user-connected-to-store'))
        );
        break;

      case Errors.USER_HOURLY_LIMIT_REACHED_SHOP:
        dispatch(
          promptToast(
            'error',
            t('reviews', 'error.user-hourly-limit-reached-shop')
          )
        );
        break;

      case Errors.USER_HOURLY_LIMIT_REACHED_ALL_SHOPS:
        dispatch(
          promptToast(
            'error',
            t('reviews', 'error.user-hourly-limit-reached-all-shops')
          )
        );
        break;

      case Errors.UNDER_INVESTIGATION:
        dispatch(
          promptToast('error', t('reviews', 'error.under-investigation'))
        );
        break;

      case Errors.INVALID_PARAMETER:
        dispatch(promptToast('error', t('reviews', 'dialog.unknown-error')));
        break;

      default:
        dispatch(promptToast('error', t('reviews', 'dialog.unknown-error')));
        break;
    }
  }

  return dispatchReviewErrorToast;
}
